// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c7041b4","239":"bc6d041c","455":"a773e324","488":"a81189c2"}[chunkId] + ".chunk.js";
};